export default __webpack_public_path__ + "static/media/ert_bg.3eaff343.jpg";